import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ThemeService } from 'src/app/theme.service';

/**
 * HTTP Interceptor to handle authentication errors globally
 * Automatically logs out the user and redirects to login when:
 * - 401 Unauthorized status is received
 * - "Unauthenticated" message is returned from the API
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const themeService = inject(ThemeService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Check for 401 Unauthorized error
      if (error.status === 401) {
        console.warn('🔒 Authentication failed: Token expired or invalid');
        handleAuthError(router, themeService);
        return throwError(() => error);
      }

      // Check for "Unauthenticated" message in response
      if (error.error?.message === 'Unauthenticated.') {
        console.warn('🔒 Authentication failed: Unauthenticated message received');
        handleAuthError(router, themeService);
        return throwError(() => error);
      }

      // For other errors, just pass them through
      return throwError(() => error);
    })
  );
};

/**
 * Clears user session and redirects to login page
 */
function handleAuthError(router: Router, themeService: ThemeService): void {
  // Clear all stored authentication data
  themeService.clearThemeId();
  localStorage.clear();
  
  // Redirect to login page
  router.navigate(['/'], { 
    queryParams: { sessionExpired: 'true' }
  });
}
